module.exports = __webpack_public_path__ + "static/media/2.99e21908.jpg";